<template>
  <section class="no-transition" :class="style.gdpr">
    <div class="content scrollable">
      <input-field class="hidden-input" />
      <div class="header">
        <h2>{{ app.country.code == 'GB' ? i18n.t('GDPR:title_secondary') : i18n.t('GDPR:title') }}</h2>
      </div>
      <ul class="items">
        <li class="item" v-for="item in items">
            <div class="value">
              <template v-if="item.hasLink">
                 {{ i18n.t(`${copyNamespace}:${item.namespace}.item_text_start`, i18nNamespaceParams(item.namespace)) }}
                 <a href="#"  @click.prevent="openModal(item.namespace)">{{ i18n.t(`${copyNamespace}:${item.namespace}.item_text`, i18nNamespaceParams(item.namespace)) }} </a>
                {{ i18n.t(`${copyNamespace}:${item.namespace}.item_text_end`, i18nNamespaceParams('age')) }}
              </template>
              <template v-else>{{ i18n.t(`${copyNamespace}:${item.namespace}.item_text`, i18nNamespaceParams(item.namespace)) }} </template>
            </div>
            <toggle-button 
            :locked="item.locked"
            class="toggle-button"
            :isChecked="consent[item.namespace] && consent[item.namespace].consent"
            :filters="filters"
            :dispatchKey="'updateConsent'"
            :propertyName="item.namespace" />
        </li>
      </ul>
      <ul class="promo-container-small">
        <li v-if="user.promoCode" :key="'b3'" class="havePromoCode">
          <div class="">
            <div class="label">{{i18n.t('promoCode:promocode')}}</div>
            <div class="value">{{user.promoCode}}</div>
          </div>
          <div>
            <button @click="displayPromoCodeModal()">{{ i18n.t('base:edit') }}</button>
          </div>         
        </li>
        <li v-else :key="'b3'" class="promoCode" @click="displayPromoCodeModal()">
          <div class="promocode-icon"></div>
          <span > I have a promo code</span>
        </li>
      </ul>
    </div>
    <ul class="promo-container">
      <li v-if="user.promoCode" :key="'b3'" class="havePromoCode">
        <div class="">
          <div class="label">{{i18n.t('promoCode:promocode')}}</div>
          <div class="value">{{user.promoCode}}</div>
        </div>
        <div>
          <button @click="displayPromoCodeModal()">{{ i18n.t('base:edit') }}</button>
        </div>         
      </li>
      <li v-else :key="'b3'" class="promoCode" @click="displayPromoCodeModal()">
        <div class="promocode-icon"></div> 
        <span>I have a promo code </span>
      </li>
    </ul>
    <action-bar>
        <transition-group tag="ul" mode="out-in" name="fade">
          <li :key="'b1'" v-if="isSubmittable" @click="confirm" class="primary custom-primary" :class="{saving: isSaving}">
            <span>{{ i18n.t(`GDPR:confirm`) }}</span>
          </li>
          <li :key="'b2'" v-else @click="toggleAll" class="secondary">
            <span>{{ i18n.t(`GDPR:select_all`) }}</span>
          </li>
        </transition-group>
    </action-bar>
    <transition name="fade">
      <info-modal v-if="showInfoModal">
        <template slot="title">
          <span class="modal-title">{{ i18n.t(`${copyNamespace}:general.in_order_to`) }}</span>
        </template>
        <template slot="content">
          <ul class="modal-content">
            <li class="modal-value" v-for="item in mandatoryConsents" :key="item.namespace" v-show="consent[item.namespace] && !consent[item.namespace].consent">
                <span> {{ i18n.t(`${copyNamespace}:${item.namespace}.item_text`, i18nNamespaceParams('age')) }}   {{ i18n.t(`${copyNamespace}:${item.namespace}.item_text_end`, i18nNamespaceParams('age')) }}</span>
            </li>
          </ul>
        </template>
        <template slot="actions">
          <span @click="closeInfoModal">{{ i18n.t(`${copyNamespace}:general.modal_button`) }}</span>
        </template>
      </info-modal>
    </transition>
    <modal :title="modalTitle" v-if="modalShown" @closeModal="closeModal" :content="modalContent" />
  </section>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "../assets/mixins";

ul {
  @include button-list;

  li {
    text-align: center;
    padding: 0;
  }
}
section {
  margin-top: 0 !important;

  & .content {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 100px;
    padding: 30px 30px;
    margin: -30px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    height: calc( 100% - 230px);

    @include desktop {
      height: calc( 100% - 173px);
    }

    @include desktop-big {
      height: calc( 100% - 230px);
    }

    @media (max-width: #{$small-phone-width}) {
      bottom: 60px;
    }

    @include desktop-big {
      margin-top: -5px;
      overflow: hidden !important;
    }
  }
}
.modal-container {
  top: 0 !important;

  .header {
    @include desktop-big {
      margin-top: 10px !important;
    }
  }

  .content {
    padding: 30px;
  }
}
.hidden-input {
  top: -1000px;
  position: absolute;
}

h2 {
  font-family: $mainFontFamily;
  color: $blackTextColor;
  font-size: 23px;
  font-weight: bold;
  line-height: 28px;
  width: 242px;
  white-space: pre-line;

  @include desktop {
    white-space: unset;
  }
  
  @include desktop-big {
    font-size: 24px;
    line-height: 30px;
    width: 340px;
  }
}

.actions {
  background-color: $actionButtonBackground !important;
  bottom : -30px !important;
  
  @include desktop {
    padding: 13px 30px !important;
  }

  ul {
    position: relative;
    height: 90px;
  }

  li {
    width: 100%;
    height: 65px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: $actionBarButtonRadius;
    border: 2px solid $actionBarButtonBackground;
    font-size: 20px;

    &.primary {
      background: $actionBarButtonBackground;
      color: $blackTextColor;
      font-weight: $boldFontWeight;
      span {
        color: $actionBarButtonColor !important;
      }
    }

    &.secondary {
      background: transparent;
      span {
        color: $actionNormalColor;
        font-weight: $boldFontWeight;
      }
    }
  }
}

.promo-container {
  position: absolute;
  bottom: 82px;
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 100;
  padding-top: 5px;
  background-color: white;
  display: none;
  @include desktop {
    display: none
  }

  @include desktop-big {
    display: block;
    bottom: 80px;
  }
  
  .promoCode{
    border: 1px dashed #3c485938;
    height: 49px;
    text-align: left;
    padding-left: 20px;
    color: #3C4859;
    display: flex;
    align-items: center;
    font-weight: 700!important;

    span {
      display: flex;
      align-items: center;
      color: #3C4859;

      img {
        margin-right: 5px;
      }
    }
  }
  .havePromoCode{
    border: 1px dashed #3c485938 !important;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px;
    
    .label{
      color: #626C79;
      font-weight: $confirmItemLabelWeight;
      font-size: $confirmItemLabelSize;
      line-height: 22px;
      text-align: justify;
      padding-left: 10px;
    }
    .value {
      font-size: 16px;
      color: #3D3D3D;
      font-weight: bold;
      line-height: 1.5rem; // 24px
      padding-right: 25px;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 210px;
      padding-left: 10px;
    }
    button {
      color: #003C5A;
      font-weight: bold;
      background-color: #EFF3F5;
      border-radius: 14px;
      text-decoration: none;
      font-size: 11px;
      cursor: pointer;
      position: relative;
      width: 59px;
      height: 28px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      padding-left: 39px;

      &::before {
        content: '';
        background-image: url('~static/edit.svg');
        width: 9px;
        height: 9px;
        margin-right: 3px;
        position: absolute;
        left: 16px;
      }

      &.saving {
        color: transparent;
        background: #00B768;
        
        &::before {
          display: none;
        }

        &::after {
          content: '';
          width: 12px;
          height: 6px;
          border: 2px solid white;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 4px;
          margin: auto;
          border-right: none;
          border-top: none;
          transform: rotate(-45deg);
          animation: arrow-check .4s cubic-bezier(0,-0.05,0,1.01) forwards;
        }
      }
    }
  }
}

.promo-container-small {
  position: relative;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 100;
  padding-top: 5px;
  background-color: white;
  display: block;

  @include desktop {
    display: block;
    width: 104%
  }
  @include desktop-big {
    display: none;
    bottom: 105px;
  }
  
  .promoCode{
    border: 1px dashed #3c485938;
    height: 49px;
    text-align: left;
    padding-left: 20px;
    color: #3C4859;
    display: flex;
    align-items: center;
    font-weight: 700!important;

    span {
      display: flex;
      align-items: center;
      color: #3C4859;

    }
  }
  .havePromoCode{
    border: 1px dashed #3c485938 !important;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px;
    
    .label{
      color: #626C79;
      font-weight: $confirmItemLabelWeight;
      font-size: $confirmItemLabelSize;
      line-height: 22px;
      text-align: justify;
      padding-left: 10px;
    }
    .value {
      font-size: 16px;
      color: #3D3D3D;
      font-weight: bold;
      line-height: 1.5rem; // 24px
      padding-right: 25px;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 210px;
      padding-left: 10px;
    }
    button {
      color: #003C5A;
      font-weight: bold;
      background-color: #EFF3F5;
      border-radius: 14px;
      text-decoration: none;
      font-size: 11px;
      cursor: pointer;
      position: relative;
      width: 59px;
      height: 28px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      padding-left: 39px;

      &::before {
        content: '';
        background-image: url('~static/edit.svg');
        width: 9px;
        height: 9px;
        margin-right: 3px;
        position: absolute;
        left: 16px;
      }

      &.saving {
        color: transparent;
        background: #00B768;
        
        &::before {
          display: none;
        }

        &::after {
          content: '';
          width: 12px;
          height: 6px;
          border: 2px solid white;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 4px;
          margin: auto;
          border-right: none;
          border-top: none;
          transform: rotate(-45deg);
          animation: arrow-check .4s cubic-bezier(0,-0.05,0,1.01) forwards;
        }
      }
    }
  }
}


.promocode-icon{
  width: 15px;
  height: 15px;
  -webkit-mask-image: url('~static/plus-circle.svg');
  mask-image: url('~static/plus-circle.svg');
  mask-repeat: no-repeat;
  mask-size: cover;
  margin-right: 7px;
}

.items {
  list-style-type: none;
  margin: 20px -30px 50px;

  .item {
    border-top: 1px solid #F1F1F1;
    padding: 15px 30px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    cursor: initial;
    @include desktop-big {
      margin: 0 30px !important;
      padding: 12px 0 !important;

      &:first-of-type {
        border-top: none;
      }
    }
  }
  li:last-of-type {
    border-radius: 0px;
    border-bottom: 1px solid #F1F1F1 !important;
  }
  .value {
    font-size: $GDPRTextSize;
    font-family: $mainFontFamily;
    color: $GDPRTextColor;
    font-weight: $GDPRTextWeight;
    line-height: $GDPRTextLineHeight;
    text-align: left;
    padding-right: 11px;
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: normal;
    & a {
      color: $GDPRLinkColor;
      font-size: $GDPRTextSize;
      font-weight: $GDPRTextWeight;
      text-decoration: none;
    }
  }
}
</style>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import ActionBar from '../components/ActionBar'
import ToggleButton from '../components/ToggleButton'
import InfoModal from '../components/InfoModal'

export default Vue.component('GDPR-screen', {
  
  components: {
    'action-bar': ActionBar,
    'toggle-button': ToggleButton,
    'info-modal': InfoModal
  },
  computed: {
    ...mapState(['user', 'partner', 'customData', 'GDPR', 'app']),
    style () {
        return {
          gdpr: this.$css(`
            h2 {
              font-family: ${this.theme.mainFontFamily} !important;
              color: ${this.theme.GDPRTextColor} !important;
            }
            .promocode-icon {
               background-color: ${this.theme.actionBarButtonBackground} !important;
            }
            .actions {
              background-color: ${this.theme.actionButtonBackground} !important;

              li:not(.promoCode, .havePromoCode) {
                border-radius: ${this.theme.actionBarButtonRadius} !important;
                border: 1px solid ${this.theme.actionBarButtonBackground} !important;

                &.primary {
                  background: ${this.theme.actionBarButtonBackground} !important;
                  color: ${this.theme.blackTextColor} !important;
                  font-weight: ${this.theme.boldFontWeight} !important;
                  span {
                    color: ${this.theme.actionBarButtonColor} !important;
                  }
                }

                &.secondary {
                  span {
                    color: ${this.theme.actionNormalColor} !important;
                    font-weight: ${this.theme.boldFontWeight} !important;
                  }
                }
              }
            }

            .items {
              .value {
                font-size: ${this.theme.GDPRTextSize} !important;
                font-family: ${this.theme.mainFontFamily} !important;
                color: ${this.theme.GDPRTextColor} !important;
                font-weight: ${this.theme.GDPRTextWeight} !important;
                line-height: ${this.theme.GDPRTextLineHeight} !important;
                & a {
                  color: ${this.theme.GDPRLinkColor} !important;
                  font-size: ${this.theme.GDPRTextSize} !important;
                  font-weight: ${this.theme.GDPRTextWeight} !important;
                }
              }
            }
          `)
        }
    },
    consent () {
      return this.$store.state.consent
    },
    mandatoryConsents () {
      return this.items.filter(item => item.locked || item.mandatory)
    },
    isMandatoryConsentToggled () {
      return this.mandatoryConsents
             .every(item => this.consent[item.namespace] && this.consent[item.namespace].consent)
    },
    isSubmittable () {
      return this.items
             .filter(item => this.consent[item.namespace] && this.consent[item.namespace].consent)
             .length > 0
    }
  },
  props: ['screenParams'],
  data () {
    const { code: countryCode } = this.$store.state.app.country
    const GDPRLevel = this.$store.state.GDPR.selected
    const copyNamespace = `${GDPRLevel}GDPR`
    const GDPR = this.$store.state.GDPR
    const items = GDPR.modes[`${GDPRLevel}_${countryCode}`] ||  GDPR.modes[GDPRLevel]
    
    return {
      copyNamespace: copyNamespace,
      items: items,
      filters: [{ value: false }, { value: true }],
      modalTitle: '',
      modalContent: '',
      modalLink: '',
      modalShown: false,
      isSaving: false,
      showInfoModal: false
    }
  },
  methods: {
    displayPromoCodeModal () {
      this.$store.commit('updateFieldEdit', {
        active: true,
        field: 'promo-code'
      })
    },
    confirm () {
      if(!this.isMandatoryConsentToggled) {
        this.showInfoModal = true
        return
      }

      this.$store.dispatch('updateGDPR', {
        accepted: true
      })
      this.$store.dispatch('replace', {...this.screenParams.nextScreenRoute, skipDelay: true})
      const input = this.$el.querySelector('input')
      if (input) {
        input.focus()
      }
    },
    setTermsContent (namespace) {
       let namespacesWithLink = ['terms', 'privacy', 'bonusPolicy']

       if (namespacesWithLink.includes(namespace)) {
         const country = this.partner.country || this.$store.state.app.country.code

         this.modalTitle = this.i18n.t(`${namespace}:title`)
         this.modalContent = this.i18n.t(`${namespace}:content`)

         if (this.customData && this.customData.terms_links && this.customData.terms_links[namespace]) {
           this.modalLink = this.customData.terms_links[namespace]
         } else {
           this.modalLink = typeof this.i18n.t(`${namespace}:link`) === 'string'
           ? this.i18n.t(`${namespace}:link`)
           : this.i18n.t(`${namespace}:link.${country}`) || this.i18n.t(`${namespace}:link.default`)
         }
       } else {
         this.modalTitle = this.i18n.t(`${this.copyNamespace}:${namespace}.link_title`)
         this.modalContent = this.i18n.t(`${this.copyNamespace}:${namespace}.link_content`)
         this.modalLink = ''
       }
    },
    openModal (namespace) {
      this.setTermsContent(namespace)
      if (this.modalLink && this.partner.externalLinks.enabled) {
        this.partner.externalLinks.partnerModal ? this.$postmate.emit('event', { type: `${namespace}` })
        : this.$postmate.emit('initExternalFrame', {
          title: this.modalTitle,
          src: this.modalLink
        })
      } else {
        this.modalShown = true
      }
    },
    closeModal () {
      this.modalShown = false
    },
    closeInfoModal () {
      this.showInfoModal = false
    },
     toggleAll () {
      let answerData = []
      this.items.forEach(item => {
        answerData[item.namespace] = {
          consent: true
        }
      })

      this.$store.dispatch('updateConsent', answerData)
    },
    i18nNamespaceParams (namespace) {
      let paramsObj = {}

      if (namespace === 'age') {
        paramsObj.age = this.partner.minimumBirthAge[this.user.country] ? this.partner.minimumBirthAge[this.user.country] : this.partner.minimumBirthAge.default
      }

      return paramsObj
    }
  },
  watch: {
    modalShown () {
      this.$emit('tooltip', this.modalShown ? ['esc'] : ['enter'])
    },
    isSaving () {
      if (this.isSaving) {
        this.$emit('tooltip', 'hide')
      }
    }
  },
  mounted () {
    this.$emit('tooltip', ['enter'])
  }
})
</script>



// WEBPACK FOOTER //
// src/screens/GDPR.vue